<script lang="ts">
    import SideMenu from "./Side.svelte";
	import OverTopLogin from "./OverTopLogin.svelte";
    import { UserCredential } from "../script/store";

    let userRoleInfo = null;
    let overlayActive = true;
    let sideMenuExpanded = true;
    $: {
        sideMenuExpanded = !overlayActive;
    }

    UserCredential.subscribe((userData) => {
        if (userData) {
            userRoleInfo = userData.roleInfo;
            overlayActive = false;
        } else {
            userRoleInfo = null;
            overlayActive = true;
        }
    });
</script>

<SideMenu bind:expanded={sideMenuExpanded}>
    <OverTopLogin bind:overlayActive />
    <div class="content">
        <div class="header">
            <div class="headerContent">
                <span>Kalibrační Modul</span>
            </div>
            <div class="headerSplit">
                <div class="roleInfo">
                    {#if userRoleInfo}
                        <span class="material-icons">
                            {userRoleInfo.iconName}
                        </span>
                        <span>
                            {userRoleInfo.displayedName}
                        </span>
                    {:else}
                        <span> Nepřihlášen </span>
                    {/if}
                </div>
            </div>
        </div>
        <slot />
    </div>
</SideMenu>

<style>
    .content {
        min-height: 100%;
        display: flex;
        flex-direction: column;
    }
    .header {
        background: var(--back);
        display: grid;
        grid-template-columns: 5fr 4fr;
        border-bottom: var(--prim_D2) 1px solid;
    }
    .headerContent > span {
        font-size: 1.5rem;
        font-weight: 400;
        padding: 0.8rem 2rem;
    }
    .headerContent {
        padding: 0.8rem 0;
    }
    .headerSplit {
        clip-path: polygon(0 0, 100% 0, 100% 100%, 2.5rem 100%);
        background: var(--prim);
        height: 100%;
        display: flex;
        justify-content: flex-end;
    }
    .roleInfo {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.3rem;
        font-weight: 500;
        color: white;
        padding: 0.5rem 1.5rem;
    }
    .roleInfo > .material-icons {
        margin-right: 10px;
        font-size: 1.3em;
    }

    /* @media only screen and (min-width: 800px) {
        .burgerMenu {
            display: none;
        }
    } */
</style>
